var LearningOutcomes = {

    init: function () {
        LearningOutcomes.bindPupilSearch();
        LearningOutcomes.bindToggleSkills();
    },

    bindPupilSearch: function() {
        $('#learning-outcomes-pupil-search').select2({
            ajax: {
                url: '/admin/pupils/ajax',
                placeholder: 'Search by Pupil Name',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                results: function (data, page) {
                    return { results: data.results };
                },
            },
            minimumInputLength: 3
        }).on('select2:select', function(e) {
            window.location.href = '/learning-outcomes?pupil=' + $(this).select2('data')[0].id;
        });
    },

    bindToggleSkills: function() {
        $('input[name^="outcome"]').click(function(){
            var $radio = $(this);
            var $rowId = $radio.closest('tr').attr('id');

            // if this is checked
            if ($radio.hasClass('ischecked'))
            {
                $radio.removeClass('ischecked');
                $radio.prop('checked', false);
            }
            else
                $radio.addClass('ischecked');

            // remove checked from other radios
            //$radio.siblings($rowId+' input[name^="outcome"]').removeClass('ischecked').prop('checked', false);
            $('#'+$rowId+' input[name^="outcome"]').each(function () {
                var checkedName = $radio.attr('name');
                var otherName = $(this).attr('name');
                //alert('Checked name '+checkedName);
                //alert('Name to be unchecked '+otherName);
                if (otherName != checkedName) {
                    $(this).removeClass('ischecked').prop('checked', false);
                }
            });
        });
    }
}
